import { DialogContext, IIdentity } from '.';

export interface DialogData<T extends IIdentity> {
  context: DialogContext<T>;
}
